import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRotate90Left20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconRotate90Left20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M15 10.5v3h1.5a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1V8h3a2.5 2.5 0 0 1 2.5 2.5m1.5 4.5H15v1.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 16.5v-6A2.5 2.5 0 0 1 3.5 8H8V3.5A2.5 2.5 0 0 1 10.5 1h6A2.5 2.5 0 0 1 19 3.5v9a2.5 2.5 0 0 1-2.5 2.5m-14-4.5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1zM4.421 1H6.5v1.5H4.421C3.404 2.5 2.5 3.284 2.5 4.25V6.5H1V4.25C1 2.455 2.532 1 4.421 1"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRotate90Left20);
